module.exports = __webpack_public_path__ + "media/get-started/bubbles-de58bdac.png";